import React from 'react';
import { Typography } from '@mui/material';

export const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <Typography sx={{ fontSize: 18, fontWeight: 500, lineHeight: '24px' }}>{children}</Typography>
);
